import queryKeys from '@/constants/queryKeys';
import { getScreenerById } from '@/services/api/requests/assessment';
import { useQuery } from '@tanstack/react-query';

const useScreenerById = (screenerId?: string) => {
  const { isLoading, data, isError, isSuccess } = useQuery({
    enabled: !!screenerId,
    queryKey: [queryKeys.assessment.screenerById, screenerId],
    queryFn: () => getScreenerById(screenerId as string),
  });

  return {
    isLoading,
    data,
    isError,
    isSuccess,
  };
};

export default useScreenerById;
